import { Event } from "./Emitter"

export enum ScreenSize {
    Mobile = 767,
    Tablet = 1170,
    Desktop = 9999,
}

class UIStore {
    Changed: Event = new Event();

    private _sidebarMinimized: boolean = false;
    public get sidebarMinimized() {
        return this._sidebarMinimized;
    }

    private _screenType: ScreenSize = ScreenSize.Desktop;
    public get screenType() {
        return this._screenType;
    }


    toggleSidebar() {
        this.setSidebarMinimizedInternal(!this._sidebarMinimized)
    }

    closeSidebarIfNecessary() {
        if (this._screenType === ScreenSize.Mobile && !this.sidebarMinimized)
            this.setSidebarMinimizedInternal(true);
    }

    private setSidebarMinimizedInternal(value: boolean) {
        if (this._screenType === ScreenSize.Mobile) {
            if (value) {
                document.body.classList.remove("show-sidebar");
            } else {
                document.body.classList.add("show-sidebar");
            }
        }
        else {
            if (value) {
                document.body.classList.add("mini-sidebar");
            } else {
                document.body.classList.remove("mini-sidebar");
            }
        }

        this._sidebarMinimized = value;
        this.Changed.emit();
    }

    onWindowResize(screenWidth: number) {
        if (screenWidth <= ScreenSize.Tablet) {
            document.body.classList.add("mini-sidebar");
        } else {
            document.body.classList.remove("mini-sidebar");
        }
        if (screenWidth <= ScreenSize.Mobile) {
            if (this._screenType != ScreenSize.Mobile) {
                this._screenType = ScreenSize.Mobile;
                this.setSidebarMinimizedInternal(true);
                this.Changed.emit();
            }
        }
        else if (screenWidth <= ScreenSize.Tablet) {
            if (this._screenType != ScreenSize.Tablet) {
                this._screenType = ScreenSize.Tablet;
                this.setSidebarMinimizedInternal(true);
                this.Changed.emit();
            }
        }
        else {
            if (this._screenType != ScreenSize.Desktop) {
                this._screenType = ScreenSize.Desktop;
                this.setSidebarMinimizedInternal(false);
                this.Changed.emit();
            }
        }
    }

}

export default new UIStore();